export const rankingConstants = {
  GET_RANKING_REQUEST: 'GET_RANKING_REQUEST',
  GET_RANKING_SUCCESS: 'GET_RANKING_SUCCESS',
  GET_RANKING_FAILURE: 'GET_RANKING_FAILURE',

  GET_RANKING_MOBILE_REQUEST: 'GET_RANKING_MOBILE_REQUEST',
  GET_RANKING_MOBILE_SUCCESS: 'GET_RANKING_MOBILE_SUCCESS',
  GET_RANKING_MOBILE_FAILURE: 'GET_RANKING_MOBILE_FAILURE',

  SET_LIMIT: 'SET_LIMIT',
  SET_PAGE: 'SET_PAGE',
  SET_FILTER: 'SET_FILTER',
};
